import PropTypes from 'prop-types';
import { translate } from 'rcffus-sps-translations';
import React from 'react';

const GermanySpecificFooter = ({
  locale,
  GermanyFiscalValues
}) => {
  if (locale !== 'de-DE') {
    return <></>;
  }

  if (!Object.keys(GermanyFiscalValues).length) {
    return (
      <>
        <section>
          <p>TSE* ist nicht erreichbar*</p>
        </section>
        <br />
        <br />
      </>
    );
  }

  const {
    ClientID,
    EndDateTime,
    HashAlgorithm,
    PublicKey,
    SequenceNumber,
    SerialNumber,
    Signature,
    SignatureCount,
    StartDateTime,
    TimeZone
  } = GermanyFiscalValues;

  return (
    <section>
      <article className="justify-between">********************************************************</article>
      <article className="justify-between align-left display-block">
        <p>TSE-{translate('RL_TransactionNo', locale)}: {SequenceNumber}</p>
        <p>TSE-{translate('RL_Start', locale) || 'Start'}: {StartDateTime}</p>
        <p>TSE-{translate('RL_Stop', locale) || 'Stop'}: {EndDateTime}</p>
      </article>
      <br /><br />
      <article className="justify-between align-left">
        <p>TSE-{translate('RL_SerialNum', locale)}: {SerialNumber}</p>
      </article>
      <br /><br />
      <article className="justify-between align-left display-block">
        <p>TSE-{translate('RL_Signature', locale)}: {Signature}</p>
        <p>TSE-{translate('RL_Hashalgorithms', locale) || 'Hashalgorithms'}: {HashAlgorithm}</p>
        <p>TSE-{translate('RL_SignatureCount', locale)}: {SignatureCount}</p>
      </article>
      <br /><br />
      <article className="justify-between align-left display-block">
        <p>TSE-{translate('RL_PublicKey', locale) || 'PublicKey'}: {PublicKey}</p>
        <p>TSE-{translate('RL_TimeFormat', locale)}: {TimeZone}</p>
      </article>
      <br /><br />
      <article className="justify-between align-left">
        <p>{translate('RL_ClientID', locale) || 'ClientID'}: {ClientID}</p>
      </article>
      <article className="justify-between">********************************************************</article>
    </section>
  );
};

GermanySpecificFooter.defaultProps = {
  GermanyFiscalValues: {}
};

GermanySpecificFooter.propTypes = {
  GermanyFiscalValues: PropTypes.shape({
    ClientID: PropTypes.string,
    EndDateTime: PropTypes.string,
    HashAlgorithm: PropTypes.string,
    PublicKey: PropTypes.string,
    SequenceNumber: PropTypes.string,
    SerialNumber: PropTypes.string,
    Signature: PropTypes.string,
    SignatureCount: PropTypes.string,
    StartDateTime: PropTypes.string,
    TimeZone: PropTypes.string
  }),
  locale: PropTypes.string.isRequired
};

export default GermanySpecificFooter;
